import React from "react";

interface Props {
  studentNotes: any[];
}

const NoteListStatistique: React.FC<Props> = ({ studentNotes }) => {
  const total = studentNotes?.length || 0;
  const validated = studentNotes?.filter((s) => {
    const m = parseFloat(String(s?.moyenne ?? ""));
    return !isNaN(m) && m >= 10;
  }).length;
  const notValidated = total - validated;
  const percent = total > 0 ? ((validated / total) * 100).toFixed(1) : "0.0";

  return (
    <div className="d-flex flex-wrap gap-3 mb-0">
      <div className="card p-2" style={{ minWidth: 160 }}>
        <div className="small text-muted">Nombre d'étudiants</div>
        <div className="h4 mb-0">{total}</div>
      </div>

      <div className="card p-2" style={{ minWidth: 160 }}>
        <div className="small text-muted">Validé</div>
        <div className="h4 mb-0 text-success">{validated}</div>
      </div>

      <div className="card p-2" style={{ minWidth: 160 }}>
        <div className="small text-muted">Non validé</div>
        <div className="h4 mb-0 text-danger">{notValidated}</div>
      </div>

      <div className="card p-2" style={{ minWidth: 160 }}>
        <div className="small text-muted">Taux de réussite</div>
        <div className="h4 mb-0">{percent}%</div>
      </div>
    </div>
  );
};

export default NoteListStatistique;
